import { useContext, useMemo } from 'react';
import type { FormConfig, Subsection } from '../config/types';
import { FormConfigContext } from '../context/FormConfigContext';
import { getEnabledSubsections } from '../utils/config-utils';
import { useFormData } from './useFormData';

export const useFormConfig: () => {
  formConfig: FormConfig;
  enabledSubsections: Record<string, Subsection>;
  isLoading?: boolean;
  error?: Error | null;
  portalComponent?: React.ReactNode;
} = () => {
  const { config: formConfig, isLoading, error, portalComponent } = useContext(FormConfigContext);
  if (!formConfig) {
    throw new Error('useFormConfig must be used within a FormConfigProvider');
  }
  const { data } = useFormData();
  const enabledSubsections = useMemo(() => getEnabledSubsections(formConfig, data), [data]);

  return {
    formConfig,
    enabledSubsections,
    isLoading,
    error,
    portalComponent,
  };
};
